/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Breadcrumb, Modal, Button } from 'semantic-ui-react'
import { getFormValues, reduxForm } from 'redux-form'
import ReactTable from 'react-table'

import CompareChart from './ComparisonTable'
import { fetchProducts, clearProducts, addProductWishlist, removeProductWishlist } from '../../ducks/product'
import { ProductContainer } from './styled'
import { MainBodyContent, SearchVendorList} from '../../components'
import ProductCell from './ProductCell'

const Products = (props) => {
  useEffect(() => {
    props.fetchProducts({page: currentPage, pageSize: recordsPerPage})

    return (()=>{
      props.clearProducts()
    })
  }, [])

  const itemsPerRow = 6
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(30)
  const [open, setOpen] = React.useState(false)

  const { 
    products, 
    wishlist,
    paginate,
    valueForm,
    addProductWishlist,
    removeProductWishlist
  } = props

  const columns = {
    list: [
      {
        Header: '',
        accessor: '',
        Cell: row => (<ProductCell product={row.row._original} onWishlistClick={addProductWishlist} />)
      }
    ],
  }

  const onHideCallback = (productId) => {
    removeProductWishlist(productId)
  }

  const features = [
    'Status',
    'Product Code',
    'Product Name',
    'Brand',
    'Model',
    'Vendor',
    'Material',
    'Size',
    'Color',
    'Price List',
    'Discount',
    'Price After Discount',
    'Gross Weight',
    'Net Weight',
    'Unit',
    'Minimum Order',
    'Delivery Time',
  ];
  
  return (
    <>
      <MainBodyContent 
        headerTitle='Products'
        breadcrumbs={
          <Breadcrumb 
            icon='right angle' 
            sections={[
              { key: 'Products', content: 'Products', active: true }
            ]}
          />
        }
      >
        <ProductContainer>
          <SearchVendorList 
            placeholder='Search by code, name, model or brand' 
            fetchAPI={props.fetchProducts} 
            formSearchName='productsSearchForm' 
            pageSize={recordsPerPage}
            filterProductStatus
            filterVendor
          />
          <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
            <Link to="#" style={{margin: '10px 0'}} onClick={() => setOpen(true)}>
              <i ariaHidden={true} className='balance scale'></i>
              Your Wishlist ({wishlist.length})
            </Link>
          </div>
          <ReactTable 
            data= {products}
            noDataText='No Item Found'
            isShowTableSwitcher={false}
            columns={columns.list}
            defaultPageSize={5}
            previousText='previous'
            nextText='next'
            manual
            pages={paginate.lastPage}
            pageIndex={props.currentPage + 1}
            // setPageSize={Math.ceil(recordsPerPage / itemsPerRow)}
            onPageChange={(pageIndex) => {
              setCurrentPage(paginate.currentPage)
              props.fetchProducts({...valueForm, page: pageIndex + 1, pageSize: recordsPerPage})
            }}
            onPageSizeChange={(rowsCount, pageIndex) => {
              setRecordsPerPage(rowsCount * itemsPerRow)
              props.fetchProducts({...valueForm, page: pageIndex + 1, pageSize: rowsCount * itemsPerRow})
            }}
          />
        </ProductContainer>
      </MainBodyContent>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Modal.Header>Compare Products</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <CompareChart 
              data={wishlist} 
              features={features} 
              hideItemOption={true}
              onHide={onHideCallback}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => ({
  products: state.product.products,
  wishlist: state.product.wishlist,
  paginate: state.product.paginate,
  valueForm: getFormValues('productsSearchForm')(state)
})

const mapDispatchToProps = {
  fetchProducts,
  clearProducts,
  addProductWishlist,
  removeProductWishlist,
}

const productSearchForm = reduxForm({
  form: 'productsSearchForm',
  enableReinitialize: true,
})(Products)

export default connect(mapStateToProps, mapDispatchToProps)(productSearchForm)
